import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

import { BaseComponent } from './pages/base/base.component';

export enum EStyleRoute {
  styles = 'styles',
}

export class AppStyleRoutingModule {
  public static loadRoutes() {
    CamRoutes.addRoute({
      key: EStyleRoute.styles,
      url: 'styles',
    });
  }

  public static getRouting(): Routes {
    return [
      {
        path: '',
        component: BaseComponent,
        pathMatch: 'full',
      },
    ];
  }
}
